import type { RootState } from "@/store/types";
import { computed } from "vue";
import { useStore } from "vuex";

export function useMentionable() {
    const store = useStore<RootState>();

    const campaignUserIds = computed(() => store.state.campaign.normalized.userIds);

    const members = computed(() => {
        if (!Array.isArray(campaignUserIds.value)) {
            return [];
        }

        return [...campaignUserIds.value].sort().map(id => {
            const parts = id.split("@");

            return {
                alias: false,
                label: id,
                value: parts[0]
            };
        });
    });

    const validMentions = computed(() => {
        return ["@campaign"].concat(members.value.map(({ value }) => `@${value}`));
    });

    return {
        members,
        validMentions
    };
}
